module.exports = __webpack_public_path__ + "img/index-tj3.7d661726.png";